// extracted by mini-css-extract-plugin
export default {"container":"RecentUploads_container__L7fTD","videoContent":"RecentUploads_videoContent__l7Wp9","card":"RecentUploads_card__EBi8k"};